import { useState } from "react";
import { useFirestore } from "react-redux-firebase";
import { Redirect } from "react-router-dom";

import Loading from '../components/Loading';
import UserForm from '../components/UserForm';
import Page from './Page';

const UserCreate = () => {
  const firestore = useFirestore();
  const [ isSuccess, setIsSuccess ] = useState(false);
  const [ isLoading, setIsLoading ] = useState(false);

  const onSave = async (formData) => {
    setIsLoading(true);
    try {
      await firestore.collection('users').add(formData);
      setIsSuccess(true);
    } catch (e) {}
    setIsLoading(false);
  }

  if(!isLoading && isSuccess) {
    return <Redirect to="/users" />
  }

  return (
    <Page title="Create customer" action={<></>}>
      <div className="row">
        <div className="col-12">
          <div className="card">
            { isLoading ? <Loading /> : <UserForm onSave={onSave} /> }
          </div>
        </div>
      </div>
    </Page>
  )
}

export default UserCreate;
